import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IRightBar {
    rightBarHidden: boolean
    name: string
    data: any
    fullScreen?: boolean
    halfScreen?: boolean
    actionsBar?: boolean
    scheduleBar?: boolean
    rightBarItem?: any
    disableHideOnBackdropClick?: boolean
    isButtonsShakeAnimated?: boolean
}

const getInitialState = (): IRightBar => ({
    rightBarHidden: true,
    name: '',
    data: [],
    fullScreen: false,
    halfScreen: false,
    actionsBar: false,
    scheduleBar: false,
    disableHideOnBackdropClick: false,
    isButtonsShakeAnimated: false
})

const rightBarSlice = createSlice({
    name: 'rightBarSlice',
    initialState: getInitialState(),
    reducers: {
        show: (state, action: PayloadAction<{ rightBarItem: any, disableHide: boolean }>) => {
            state.rightBarHidden = false
            state.rightBarItem = action.payload.rightBarItem
            state.disableHideOnBackdropClick = action.payload.disableHide
        },
        scheduleBar: (state, action: PayloadAction<{ rightBarItem: any }>) => {
            state.rightBarHidden = false
            state.actionsBar = false
            state.scheduleBar = true
            state.rightBarItem = action.payload.rightBarItem
        },
        actionsBar: (state, action: PayloadAction<{ rightBarItem: any }>) => {
            state.rightBarHidden = false
            state.actionsBar = true
            state.rightBarItem = action.payload.rightBarItem
        },
        fullScreen: (state) => {
            state.fullScreen = true
            state.actionsBar = false
        },
        collapse: (state) => {
            state.fullScreen = false
        },
        hide: (state) => {
            state = getInitialState()
            return state
        },
        setShakeAnimation: (state, action: PayloadAction<boolean>) => {
            state.isButtonsShakeAnimated = action.payload
        }
    },
})

export const { actions: rightBarActions } = rightBarSlice
export const { reducer: rightBarReducer } = rightBarSlice
